import axios from 'axios'
import { Message } from 'element-ui';
const BASE_API_CONFIG = {
    apiUrl: 'https://sanhaopeisong.com /',
    imgUrl: ''
};

function getAppStorage() {
    const accessToken = '';

    if (accessToken) {
        return accessToken;
    }

    return '';
}

function successFunc(data, resolve, reject) {
    const status = data.status;
    if (status === 0) {
        const resData = data.return;
        resolve(resData);
    } else {
        const message = data.message || '提交出错';

        if (status === 206 || status === 207) {
            Message.error('请重新登录');
            this.$router.push('/login')
            reject(message);
        }else {
            reject(message);
            Message.error(message);
        }
    }
}

function getApi(par, url, type = 'POST') {
    par = par || {};

    const access_token = getAppStorage();
    const promise = new Promise(function (resolve, reject) {
        axios({
            url: BASE_API_CONFIG.apiUrl + url,
            method: type,
            data: par,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'access-token': access_token
            }
        }).then((res) => {
            const data = res.data;
            successFunc(data, resolve, reject);
        }).catch((err) => {
            const message = err.message || '提交出错';
            Message.error(message);
            reject(message);
        });
    });

    return promise;
}



const API = {
    BASE_API_CONFIG,
    'apiUserLogin'(par) {
        const URL = 'api/user/login';
        return getApi(par, URL, 'POST');
    },
    'getUserInfo'(par) {
        const URL = 'api/user/user_info';
        return getApi(par, URL, 'GET');
    },

};

export default API;



// WEBPACK FOOTER //
// ./src/api/index.js